export default "__VITE_ASSET__CYa7$vDF__"